module.exports = __webpack_public_path__ + "assets/img/46f379d2c1dc4f63a91c0c6c6e579d7d.svg";